var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, TableBody, TableCell, TableRow } from '@mui/material';
import { get } from 'lodash';
var BaseTableBody = function (props) {
    var data = props.data, listSelected = props.listSelected, columns = props.columns, checkedIndex = props.checkedIndex, hasCheckBox = props.hasCheckBox, customStyle = props.customStyle, ordinalNumber = props.ordinalNumber, pagination = props.pagination, actions = props.actions, handleSelectRow = props.handleSelectRow;
    return (_jsx(TableBody, { sx: __assign({}, (customStyle && __assign({}, customStyle))), children: data.map(function (row, index) {
            return (_jsxs(TableRow, { children: [hasCheckBox && (_jsx(TableCell, { padding: 'checkbox', children: _jsx(Checkbox, { color: 'primary', checked: checkedIndex && listSelected.indexOf(row[checkedIndex]) !== -1, onChange: function () { return handleSelectRow(checkedIndex && row[checkedIndex]); } }) })), pagination
                        ? ordinalNumber && _jsx(TableCell, { children: index * pagination.limit * pagination.page })
                        : ordinalNumber && _jsx(TableCell, { children: index + 1 }), columns.map(function (headCell) { return (_jsx(TableCell, { sx: __assign({}, (headCell.customStyle && __assign({}, headCell.customStyle))), children: headCell.render ? headCell.render(row, actions) : headCell.key && get(row, headCell.key) }, headCell.id)); })] }, index));
        }) }));
};
export default BaseTableBody;
